import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import authAxios from "../../../config/authAxios"


const initialState = { status: null, loading: false, data: [], error: "", message: "",totalPages:0 }



export const publisherRevenueDetailsAction = createAsyncThunk(
    'publisher-revenue-details',
    async (data, { rejectWithValue }) => {
        try {
            const res = await authAxios.get(`/admins/api/publisher-revenue-sum?publisherId=${data?.publisherId}&startDate=${data?.startDate}&endDate=${data?.endDate}&app_id=${data?.app_id}`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const publisherRevenueDetailsSlice = createSlice({
    name: 'publisher-revenue-details',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(publisherRevenueDetailsAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(publisherRevenueDetailsAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
                state.totalPages = action?.payload?.totalPages
            })
            builder.addCase(publisherRevenueDetailsAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const publisherRevenueDetailsReducer = publisherRevenueDetailsSlice.reducer